<template>
  <b-container id="appointment-modal" fluid class="p-0">
    <b-row class="m-0">
      <b-col class="p-0">
        <FormSteps :steps="$store.state.components.quote.steps" title="Quote Scheduler" type="quote" @back="back"></FormSteps>
      </b-col>
    </b-row>
    <div class="appt-content d-flex flex-row" :class="{bk_f3: cur_stage === 'quote_confirm'}">
      <div class="select-area pd-30 scroll-area" :class="{appt_confirm: cur_stage === 'quote_confirm'}" v-if="!quoteComplete">
        <div class="appt-sub-comp">
          <div class="validation-warning" v-if="hasErrors.responseCode !== null && hasErrors.responseCode !== 1">
            <b-alert show dismissible variant="warning">
              {{ displayErrors }}
            </b-alert>
          </div>
          <appt-store v-if="cur_stage === 'quote_store'" title="1. Select a Store" @next="next" @hideModal="hideModal"></appt-store>
          <appt-service v-if="cur_stage === 'quote_service'" title="2. Select Your Service(s)" @next="next" @back="back"></appt-service>
          <appt-contact v-if="cur_stage === 'quote_contact'" title="3. Contact Info" @next="next" @back="back"></appt-contact>
          <appt-confirm v-if="cur_stage === 'quote_confirm'" title="Confirm Quote" formType="quote" @goToEdit="gotoEdit" @back="back" />
        </div>
      </div>
      <!-- @TODO - Setup a Quote Specific Success Component to Load Here -->
      <FormSuccess v-if="quoteComplete" @closeModal="hideModal"></FormSuccess>
      <!-- Start of Desktop Right Hand Review Area -->
      <div class="appt-details pd-30 scroll-area" v-if="cur_stage !== 'quote_confirm'">
        <div class="appt-cap1">Quote Details</div>
        <div class="appt-confirm-stages">
          <FormStoreReview @goToEdit="gotoEdit(0)" :number="1"></FormStoreReview>
          <FormServiceReview @goToEdit="gotoEdit(1)" :number="2"></FormServiceReview>
          <FormContactReview @goToEdit="gotoEdit(2)" :number="3"></FormContactReview>
          <div class="confirm-stage">
            <div class="d-title">
              <span class="lbl-cap8 text-bold">4. Confirm Quote</span>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Desktop Right Hand Review Area -->
    </div>
    <div class="appt-footer">
      Copyright &copy; 2022 Tint World&reg; Franchise. All rights reserved.
    </div>
  </b-container>
</template>

<script>
import FormSteps from "./../partials/FormSteps";
import FormStoreReview from "./../partials/FormStoreReview";
import FormServiceReview from "./../partials/FormServiceReview";

import FormContactReview from "./../partials/FormContactReview";
import FormSuccess from "./../quote/FormSuccess";
//import FormReview from "./../partials/FormReview";
//import ApptStore from "./ApptStore";
import ApptStore from "./../partials/FormStore";
import ApptService from "./../partials/FormServices";

import ApptContact from "./../partials/FormContact";
//import ApptConfirm from "./ApptConfirm";
import ApptConfirm from "./../quote/FormReview";

export default {
  components: {
    ApptStore,
    ApptService,
    ApptContact,
    ApptConfirm,
    FormSteps,
    FormStoreReview,
    FormServiceReview,
    FormContactReview,
    FormSuccess
  },
  data: () => {
    return {
      displayErrors: '',
    }
  },
  created() {

  },
  mounted(){
    this.$gtm.trackEvent({
      event: 'begin_checkout_quote',
      category: 'Lead',
      action: 'Started Quote',
      noninteraction: false
    });
  },
  computed: {
    hasErrors(){
      return this.$store.state.form_response;
    },
    storeSelected(){
      return this.$store.getters.formStore;
    },
    formComplete(){
      return this.$store.getters.quoteFormComplete;
    },
    quoteComplete(){
      return this.$store.getters.quoteProcessedSuccessfully;
    },
    user(){
      return this.$store.state.user;
    },
    cur_stage() {
      return this.$store.getters.currentQuoteState.name;
    },
    appointment() {
      return this.$store.state.appointment
    },
  },
  destroyed(){
    if(this.quoteComplete){
      this.$store.commit('resetUserForm',{type:'quote'});
    }
  },
  methods: {
    gotoLink(url){
      location.href = url
      this.hideModal()
    },
    hideModal() {
      this.$root.$emit('bv::hide::modal', 'tint-world-modal')
      this.$store.commit('CloseModal', 'appointment')
    },
    toggleModal() {
      this.$root.$emit('bv::toggle::modal', 'tint-world-modal')
      this.$store.commit('ToggleModal', 'appointment')
    },
    openModal(){
      this.$root.$emit('bv::toggle::modal', 'tint-world-modal')
      this.$store.commit('OpenModal', 'appointment')
    },
    back(){
      var form = {type:'quote',change:'reduce'};
      this.$store.commit('QuoteFormBack',form);
    },
    next(){
      var form = {type:'quote',change:'increment'};
      this.$store.commit('QuoteFormBack',form);
    },
    gotoEdit(int){
      // appt_store | appt_service | appt_date | appt_contact | appt_confirm
      //this.$store.commit('edit_appointment', 'appt_' + state)
      var form = {type:'quote',change:'go_to',go_to:int};
      this.$store.commit('QuoteFormBack',form);
    },
  }
}
</script>
<style>
/*
#tint-world-modal .modal-dialog .modal-content {
  width: 100vw;
  height: 100vh;
  border-width: 0;
  max-width: 100vw;
  max-height: 100vh;
}
 */
</style>